import { RouteConfig } from 'vue-router'
import Layout from '@/components/layout/index.vue'

const redirect: any = {
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [
    {
      path: '/redirect/:path(.*)',
      component: {
        created(this: any) {
          const { params, query } = this.$route
          const { path } = params
          this.$router.replace({ path: '/' + path, query })
        },
        render: function(h: any) {
          return h() // avoid warning message
        }
      }
    }
  ]
}

const routes: RouteConfig[] = [
  redirect,
  {
    path: '/',
    component: Layout,
    redirect: { name: 'Dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: { title: 'routes.dashboard', hiddenCrumbs: true, affix: true },
        component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/dashboard/dashboard.vue')
      },
      {
        path: 'personal-data/:id',
        name: 'Personal.Data',
        meta: { title: 'routes.personalData' },
        component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/personal-data/index.vue')
      }
    ]
  },
  {
    path: '/setting',
    name: 'Root.Setting',
    component: { render: (h: any) => h('router-view') },
    redirect: { name: 'Root.Setting.Dashboard' },
    children: [
      {
        path: 'dashboard',
        component: Layout,
        children: [
          {
            path: '',
            name: 'Root.Setting.Dashboard',
            meta: { title: 'routes.dashboard', affix: true },
            component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/dashboard/dashboard-setting.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/sign',
    name: 'Sign',
    component: { render(h) { return h('router-view') } },
    children: [
      {
        path: 'login',
        name: 'Sign.Login',
        meta: { title: 'routes.sign.login' },
        component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/sign/login.vue')
      },
      {
        path: 'register',
        name: 'Sign.Register',
        meta: { title: 'routes.sign.register' },
        component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/sign/register/index.vue')
      },
      {
        path: 'forgetpass',
        name: 'Sign.Forgetpass',
        meta: { title: 'routes.sign.forgetpass' },
        component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/sign/forgetpass/index.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'Page404',
    meta: { title: '404' },
    component: () => import(/* webpackChunkName: "staticpage" */ '@/views/common/404.vue')
  }
]

export default routes
